<template>
  <v-dialog v-model="show" max-width="500" @click:outside="show = false">
    <v-card max-width="500" color="greyColorLigthTwo" class="rounded-lg">
      <v-card-title class="defaultColor--text font-weight-bold"> {{ $t("title.postShare") }} </v-card-title>

      <v-card-text>
        <v-textarea
          v-model.trim="shareTitle"
          full-width
          :placeholder="$t('placeHolder.write')"
          :counter="sharedTitleCounter"
          rows="4"
        >
          <template slot="prepend-inner">
            <v-avatar class="mr-3" size="60">
              <v-img :src="$store.state.user.Avatar"></v-img>
            </v-avatar>
          </template>
        </v-textarea>
        <v-combobox
          v-model="selectedTags"
          :items="this.$store.state.tagList"
          :search-input.sync="search"
          deletable-chips
          chip
          color="defaultColor"
          v-on:keyup.enter="addNewTag()"
          class="mt-5"
          hide-selected
          item-text="TagName"
          item-value="Id"
          :label="$t('labels.addTag')"
          multiple
          persistent-hint
          :disabled="this.$store.state.tagListLoading"
          :loading="this.$store.state.tagListLoading"
          small-chips
        >
        <template #selection="{ item, parent }">
            <v-chip
              class="ma-2"
              close
              color="defaultColorLight"
              outlined
              @click:close="parent.selectItem(item)"
            >
              {{ item.TagName }}
            </v-chip>
          </template>
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("description.noContent") }}
                  "<strong>{{ search }}</strong
                  >"
                  {{ $t("description.ifTagAdd") }}
                  <kbd>Enter</kbd>
                  {{ $t("description.pressButton") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
        <v-autocomplete
          v-model="selectedUsers"
          :disabled="isUpdating"
          :loading="isLoadingUsers"
          :items="users"
          :search-input.sync="searchUserName"
          chips
          hide-selected
          hide-no-data
          color="defaultColor"
          :label="$t('labels.addUser')"
          item-text="FullName"
          item-value="Id"
          multiple
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              color="defaultColorLight"
              outlined
              @click="data.select"
              @click:close="removeUser(data.item)"
            >
              <v-avatar left>
                <v-img :src="data.item.Avatar"></v-img>
              </v-avatar>
              {{ data.item.FullName }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <template>
              <v-list-item-avatar>
                <img :src="data.item.Avatar" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title> {{ data.item.FullName }}</v-list-item-title>
                <v-list-item-subtitle
                  v-for="(groupItem, index) in data.item.Groups"
                  :key="index"
                  v-html="groupItem.Name"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="defaultColor"
          class="white--text text-capitalize"
          text
          :disabled="shareTitle.length > sharedTitleCounter"
          rounded
          @click="closeModal"
        >
          {{ $t("buttons.cancelUpper") }}
        </v-btn>

        <v-btn
          color="defaultColor"
          elevation="0"
          class="white--text text-capitalize"
          :disabled="shareButtonStatus"
          rounded
          @click="sharePost()"
        >
          {{ $t("buttons.share") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PostService from "../../services/PostService";
import UserService from "../../services/UserService";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      shareTitle: "",
      sharedTitleCounter: 250,

      search: null,
      selectedTags: [],

      users: [],
      selectedUsers: [],
      isUpdating: false,
      searchUserName: null,
      isLoadingUsers: false,
    };
  },
  props: {
    itemData: Object,
    visible: Boolean,
  },
  mounted() {},
  methods: {
    addNewTag() {
      console.log("tag", this.selectedTags[this.selectedTags.length - 1]);
      PostService.addTag(this.selectedTags[this.selectedTags.length - 1])
        .then((res) => {
          console.log("add tag :", res.data);
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        });
    },

    getUsers(userName) {
      console.log("userName :", userName);
      UserService.getUsers(userName)
        .then((res) => {
          console.log("searchUser :", res.data.Data);
          this.users = res.data.Data;
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        })
        .then(() => {
          this.isLoadingUsers = false;
        });
    },

    removeUser(item) {
      console.log("item", item);
      const index = this.selectedUsers.indexOf(item.Id);
      if (index >= 0) this.selectedUsers.splice(index, 1);
    },

    sharePost() {
      //TODO: ayarlanacak
      let tags = [];
      this.selectedTags.forEach((element) => {
        tags.push(element.Id);
      });
      let body = {
        Content: this.shareTitle,
        GroupIds: [],
        Key: "kurumsal_haberler",
        ParentId: this.itemData.Id,
        Privacy: "public",
        RelatedUserIds: this.selectedUsers,
        Status: 20,
        TagIds: tags,
        Type: "individual",
      };
      console.log("body : ", body);
      PostService.sharePost(body)
        .then((res) => {
          console.log("add share :", res.data);
          this.getPosts().then(() => {
            this.closeModal();
            showSuccess(this.$t("description.successShareContent"));
            // window.scrollTo({
            //   top: 0,
            //   left: 0,
            //   behavior: "smooth",
            // });
          });
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        });
    },

    closeModal() {
      this.shareTitle = "";

      this.search = null;
      this.selectedTags = [];

      this.users = [];
      this.selectedUsers = null;
      this.isUpdating = false;
      this.searchUserName = null;
      this.isLoadingUsers = false;
      this.show = false;
    },

    ...mapActions(["getPosts"]),
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },

    shareButtonStatus: {
      get() {
        if (
          this.shareTitle.length > this.sharedTitleCounter ||
          this.shareTitle.length <= 0
        )
          return true;
        else return false;
      },
      set(value) {
        this.shareButtonStatus = value;
      },
    },
  },
  watch: {
    searchUserName(val) {
      // Items have already been loaded
      //if (this.users.length > 0) return;

      if (val.length < 3) return;

      // Items have already been requested
      if (this.isLoadingUsers) return;

      this.isLoadingUsers = true;

      // Lazily load input items
      this.getUsers(val);
    },
  },
};
</script>
